module.exports = __webpack_public_path__ + "img/uMobi.096eec93.png";